import React from 'react';

const Projects = () => {
  return (
    <div>
      <h2 className="text-xl font-semibold text-abiu-green-dark mb-4">My Projects</h2>
      <div className="space-y-4">
        <div className="p-4 border border-gray-200 rounded-lg">
          <div className="flex justify-between items-start mb-2">
            <h3 className="font-semibold text-abiu-green-dark">Demo Project</h3>
            <span className="bg-yellow-100 text-yellow-800 px-2 py-1 rounded-full text-xs">Coming Soon</span>
          </div>
          <p className="text-gray-600 text-sm mb-2">This is a demo project. Real project tracking features are coming soon.</p>
          <div className="flex justify-between text-sm text-gray-500">
            <span>Budget: ₦0</span>
            <span>Status: Demo</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Projects; 